import { useState, useEffect } from 'react';
import { apiFetch } from '@/api';

// Cache to prevent duplicate requests when multiple nodes on screen request the same service
const cache = new Map<string, any[]>();
const inflight = new Map<string, Promise<any[]>>();

export function useServiceConnections(serviceString?: string) {
    const [connections, setConnections] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!serviceString) {
            setConnections([]);
            return;
        }

        if (cache.has(serviceString)) {
            setConnections(cache.get(serviceString)!);
            return;
        }

        setLoading(true);

        const fetchPromise = inflight.has(serviceString)
            ? inflight.get(serviceString)!
            : apiFetch(`/integrations/my-keys?service=${serviceString}`, null, { method: 'GET' })
                  .then((keys: any) => {
                      const list = Array.isArray(keys) ? keys : [];
                      cache.set(serviceString, list);
                      inflight.delete(serviceString);
                      return list;
                  })
                  .catch(() => {
                      inflight.delete(serviceString);
                      return [];
                  });

        if (!inflight.has(serviceString)) {
            inflight.set(serviceString, fetchPromise);
        }

        fetchPromise.then(data => {
            setConnections(data);
            setLoading(false);
        });
    }, [serviceString]);

    return { connections, loading };
}

export function clearServiceConnectionCache(serviceString?: string) {
    if (serviceString) {
        cache.delete(serviceString);
    } else {
        cache.clear();
    }
}
